import getApi from '../../api/apisauceConfig'
import { AudiometerInstance } from '../../model/Audiometry'

export const createAudiometerInstance = (documentId: number) =>
  getApi().post<AudiometerInstance>('/audiometry/audiometer_instances', { documentId })
